// extracted by mini-css-extract-plugin
export default {"wrapper":"ReviewTextInput_wrapper__7RV4i","textarea":"ReviewTextInput_textarea__VC9Mi"};